var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4444 71.0001H16.5564C11.4164 71.0001 7.23438 66.8491 7.23438 61.7461V39.1261C7.23438 34.0231 11.4164 29.8711 16.5564 29.8711H55.4454C60.5854 29.8711 64.7674 34.0231 64.7674 39.1261V61.7451C64.7674 66.8491 60.5844 71.0001 55.4444 71.0001ZM16.5564 34.8721C14.1734 34.8721 12.2344 36.7811 12.2344 39.1271V61.7461C12.2344 64.0921 14.1734 66.0001 16.5564 66.0001H55.4454C57.8284 66.0001 59.7674 64.0911 59.7674 61.7461V39.1261C59.7674 36.7801 57.8284 34.8711 55.4454 34.8711H16.5564V34.8721Z",
    fill: "#189D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0779 34.872H17.9219C16.5409 34.872 15.4219 33.753 15.4219 32.372V21.398C15.4219 10.151 24.6529 1 35.9999 1C47.3469 1 56.5779 10.151 56.5779 21.398V32.371C56.5779 33.752 55.4589 34.872 54.0779 34.872ZM20.4219 29.872H51.5779V21.399C51.5779 12.908 44.5899 6 35.9999 6C27.4099 6 20.4219 12.908 20.4219 21.398V29.872Z",
    fill: "#189D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62.3137C34.619 62.3137 33.5 61.1947 33.5 59.8137V55.0107C33.5 53.6297 34.619 52.5107 36 52.5107C37.381 52.5107 38.5 53.6297 38.5 55.0107V59.8137C38.5 61.1947 37.381 62.3137 36 62.3137Z",
    fill: "#189D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9969 55.0007C31.9799 55.0007 28.7109 51.7507 28.7109 47.7557C28.7109 43.7607 31.9799 40.5107 35.9969 40.5107C40.0179 40.5107 43.2889 43.7607 43.2889 47.7557C43.2889 51.7507 40.0179 55.0007 35.9969 55.0007ZM35.9969 45.5117C34.7369 45.5117 33.7109 46.5187 33.7109 47.7567C33.7109 48.9947 34.7359 50.0017 35.9969 50.0017C37.2609 50.0017 38.2889 48.9947 38.2889 47.7567C38.2889 46.5187 37.2609 45.5117 35.9969 45.5117Z",
    fill: "#189D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.1928808534fea4939f68132ae38b1085.svg";
export { ForwardRef as ReactComponent };